var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('v-progress-circular',{staticClass:"percentage",attrs:{"size":_vm.size,"rotate":-90,"color":_vm.style.main,"value":_vm.data.completion}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }